import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=bb2f90ea&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=bb2f90ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2f90ea",
  null
  
)

export default component.exports